/* ============ 左侧目录默认展开首项 ============ */
if (!$('.toc_cat.active').length) {
    $('.toc_cat').first().addClass('active');
}

/* ============ 左侧目录分类展开 ============ */
$('.toc_cat > .title').on('click', function () {
    $(this).closest('.toc_cat').toggleClass('active').siblings().removeClass('active');
});

/* ============ 目录跳转并展开对应问题 ============ */
$('.toc_sub a').on('click', function () {
    $('.faq_item').removeClass('active');
    $($(this).attr('href')).addClass('active');
});

/* ============ FAQ 手风琴 ============ */
$('.faq_item .title').on('click', function () {
    $(this).closest('.faq_item').toggleClass('active').siblings().removeClass('active');
});
